<template>

  <el-main
    class="main_content downRole"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/normal_user_list')">用户管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>销户</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">

      <div class="contain_body">
        <div class="userInfooi">
          <div class="moreUserInfo11">
            <div class="base_label">用户信息：{{normalUser.username}}（{{normalUser.telephone}}），当前级别是{{normalUser.roleType}}，保证金：{{normalUser.deposit}}元</div>
          </div>
        </div>
        <el-form
          style="width:850px;"
          ref="form"
          :model="form"
          label-width="150px"
          :rules="addFormRule"
        >

        </el-form>
        <div class="contain_body_head">
          下级代理列表
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop=""
            label="代理信息"
          >
            <template slot-scope="scope">
              {{scope.row.username}}({{scope.row.telephone}})，身份是{{scope.row.roleTypeName}}
            </template>
          </el-table-column>

          <el-table-column
            prop="upTel"
            label="上级手机号"
          >
            <template slot-scope="scope">
              <el-input
                v-show="scope.row.role_type != -1"
                placeholder="请输入新上级的手机号,必须填"
                v-model="scope.row.upTel"
              >
              </el-input>
            </template>
          </el-table-column>

          <el-table-column
            prop="recommendTel"
            label="推荐人手机号"
          >
            <template slot-scope="scope">
              <el-input
                placeholder="请输入新推荐人手机号，必填"
                v-model="scope.row.recommendTel"
              >
              </el-input>
            </template>
          </el-table-column>

        </el-table>

        <div style="display:flex;justify-content: flex-end;padding:20px 110px 0 0">
          <el-button
            type="primary"
            size="small"
            @click="submitForm"
            :loading="addLoading"
          >提交</el-button>
        </div>
      </div>

    </div>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
var _ = require("lodash");
export default {
  name: "delNormalUser",
  created() {},
  mounted() {
    var that = this;
    this.normalUser = this.$route.query.good;
    this.form.id = this.normalUser.id;
    console.info(this.normalUser);
    this.normalUser.roleType = this.formatterRoleType(this.normalUser);
    this.handleSearch();
  },
  data() {
    return {
      addFormRule: {
        role_type: [
          {
            required: true,
            message: "请选择降级的身份",
            trigger: "blur"
          }
        ]
      },
      normalUser: {},
      addLoading: false,
      form: {
        id: null,
        role_type: null,
        down_list: null
      },
      loading: false,
      tableData: []
    };
  },
  methods: {
    submitForm() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          var go = true;
          var downList = [];
          if (that.tableData.length > 0) {
            //检查是否有下级要变动的
            for (var i = 0; i < that.tableData.length; i++) {
              if (
                (that.tableData[i].upTel == null ||
                that.tableData[i].upTel == "") && that.tableData[i].role_type != -1
              ) {
                that.$message.error({
                  showClose: true,
                  message: "请检查一下有下级代理未设置新的上级",
                  duration: 2000
                });
                go = false;
              } else if (
                that.tableData[i].recommendTel == null ||
                that.tableData[i].recommendTel == ""
              ) {
                that.$message.error({
                  showClose: true,
                  message: "请检查一下有下级代理未设置新的推荐人",
                  duration: 2000
                });
                go = false;
              } else {
                downList.push(that.tableData[i]);
              }
            }
          }
          if (!go) {
            return;
          } else {
            para.down_list = JSON.stringify(downList);
            that.addLoading = true;
            API.do_out_user(para)
              .then(
                function(result) {
                  that.addLoading = false;
                  if (result.key == 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "销户成功",
                      duration: 1500
                    });
                    that.$router.push({ path: "/normal_user_list" });
                  } else if (result.key == 1001) {
                    bus.$emit("goto", "/login");
                  } else {
                    that.$message.error({
                      showClose: true,
                      message: result.message || "登录失败",
                      duration: 2000
                    });
                  }
                },
                function(err) {
                  that.loading = false;
                  console.error(err);
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.error(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          }
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    formatterRoleType(row) {
      var word = "";
      if (row.role_type == -1) {
        word = "无";
      } else if (row.role_type == -0.5) {
        word = "康减系列vip会员 ";
      } else if (row.role_type == -0.4) {
        word = "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        word = "康减系列荣誉会员";
      } else if (row.role_type == 0) {
        word = "VIP门店";
      } else if (row.role_type == 1) {
        word = "联盟店";
      } else if (row.role_type == 2) {
        word = "市代";
      } else if (row.role_type == 3) {
        word = "省代";
      } else if (row.role_type == 4) {
        word = "CEO";
      } else if (row.role_type == 1.1) {
        word =  "康减系列市代";
      } else if (row.role_type == 2.1) {
        word =  "康减系列省代";
      } else if (row.role_type == 3.1) {
        word =  "康减系列CEO";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      } else if (row.role_type == 4.8) {
        return "经销商";
      }
       else if (row.role_type == 5) {
        return "总经销商";
      }
      if (row.special_status == 2) {
        word = word + "-" + "特殊";
      }
      return word;
    },
    delGoods(row, index) {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        key: row.infoName,
        value: row.infoValue
      };
      that.loading = true;
      API.up_dic_data(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.$message.success({
                showClose: true,
                message: "上传成功",
                duration: 1500
              });
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    handleSearch() {
      this.search();
    },
    search() {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        userId: that.normalUser.id,
        type: 1,
        total: 1
      };
      that.loading = true;
      API.group_count_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.tableData = result.result.list;
              if (result.result.list != null && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].role_type =
                    result.result.list[i].roleType;
                  result.result.list[i].roleTypeName = that.formatterRoleType(
                    result.result.list[i]
                  );
                  if (result.result.list[i].up_id == that.normalUser.id)
                  {
                    result.result.list[i].infoType = 1;
                  } else
                  {
                    result.result.list[i].infoType = 2;
                  }
                }
                that.tableData = result.result.list;
              } else {
                that.tableData = [];
              }
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.userInfooi {
  flex: 1;
  display: block;
  height: auto;
  padding: 5px 0px 5px 30px;
}
.downRole .el-form-item {
  margin-bottom: 10px !important;
}
.moreUserInfo11 ul {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.moreUserInfo11 li {
  color: #666;
  width: 33.3%;
}
.moreUserInfo11 .base_label {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0;
}
.moreUserInfo11 ul li {
  line-height: 30px;
}
.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/delNormalUser.vue